import { compatWrapper } from '@backstage/core-compat-api';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGithubActionsAvailable } from
  '@backstage-community/plugin-github-actions';

const releaseStatusEntityContent = EntityContentBlueprint.make({
  params: {
    path: 'release-status',
    title: 'Release status',
    filter: isGithubActionsAvailable,
    async loader() {
      const { ReleaseStatusPage } = await import('./ReleaseStatusPage');
      return compatWrapper(<ReleaseStatusPage />);
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'release-status',
  extensions: [releaseStatusEntityContent],
});